import {api} from '../../api/access-ctrl'
import {
  registerConfig, ROUTE_NAME_OF_DI_PAGE, SHOW_IN, TYPE
} from '../../../components/common/di-ding'
import {
  periodInput,
  generatePlanTime
} from './_period-input'
import {isArray} from '../../../utils/util'
import {commonConfig, routeNameOfDi} from '../common'
import {pattern} from '../../../utils/regular'

const mapping = {
  planName: {
    label: '计划名称',
    tip: '不超过32个字',
    nullable: false,
    validate: [
      {required: true, message: '计划名不能为空'},
      {max: 32, message: '不能超过32个字'},
      {pattern: pattern.basicAndCN, message: '只允许输入中文，字母，数字，下划线'}
    ]
  },
  planTime: {
    label: '开门时段',
    showIn: [SHOW_IN.CENTER, SHOW_IN.CURRENT],
    onDataLoaded (data) {
      const generateBusinessTimeArray = (data) => {
        const ct = (time) => time.substring(0, time.length - 3)
        console.log(data)
        return [1, 2, 3].map(it =>
          data['period' + it]
            ? `${ct(data['startTime' + it])} ~ ${ct(data['endTime' + it])}`
            : null
        )
      }

      data._planTime = {
        _label: generateBusinessTimeArray(data).filter(_ => _).join('; ')
      }
    }
  },
  planTimes: {
    showIn: [SHOW_IN.CREATE, SHOW_IN.MODIFY],
    type: TYPE.RENDER_LABEL_AND_CONTENT,
    nullable: false,
    init (data) {
      data._planTimes = []
    },
    renderContent: periodInput,
    onDataLoaded (data, type) {
      if (type === 'create') {
        data._planTimes = [generatePlanTime()]
      } else {
        const planTimes = [1, 2, 3].map(it => {
          return {
            key: Math.random(),
            time: data[`period${it}`] === '1'
              ? [data[`startTime${it}`], data[`endTime${it}`]]
              : null
          }
        })
        data._planTimes = planTimes.filter(it => it.time !== null)
      }
    },
    beforeDataIsPost (data) {
      data._planTimes
        .filter(it => it.time[0] !== null)
        .forEach(({time}, i) => {
          const [startTime, endTime] = time
          const no = i + 1
          data[`period${no}`] = '1'
          data[`startTime${no}`] = startTime
          data[`endTime${no}`] = endTime
        })
    },
    validate: [
      {required: true, message: '该时段不能为空'},
      {
        validate: val => {
          return val && val.length > 0 && isArray(val[0].time)
        },
        message: '该时段不符要求'
      }
    ]
  }
}

const config = {
  breadcrumb: [{
    value: '智慧门禁',
    name: 'accessCtrlDeviceManagementCenter'
  }, {
    value: '开门计划',
  }],
  center: {
    opBar: [[ // 多少个元素代表多少行
      {
        type: 'button-add',
        label: '配置开门计划',
        onClick () {
          this.routerPush(ROUTE_NAME_OF_DI_PAGE.CREATE, {diName: routeNameOfDi.APP_CENTER_ACCESS_CTRL_OPEN_CONFIG})
        }
      },
      null
    ]],
    table: {
      operations: ['detail', 'deletePlan']
    }
  },
  current: {
    title: '查看当前开门计划'
  },
  create: {
    title: ['配置开门计划', '设置计划名称、开门时段；开门计划不区分日期，每天统一，不支持跨天设置；如无特别需要，不建议配置多个时段']
  },
  modify: {
    title: '修改开门计划'
  },

  get: requestBody => api.getOpenPlan(requestBody),
  delete: strId => api.deleteOpenPlan(strId),
  getCurrent: code => api.getOpenPlanByCode(code),
  post: data => api.postOpenPlan(data),
  patch: data => api.patchOpenPlan(data),

  mapping
}

registerConfig(routeNameOfDi.APP_CENTER_ACCESS_CTRL_OPEN_CONFIG, config)



// WEBPACK FOOTER //
// ./src/view/AccessCtrl/business-plan/business-plan.js